import React from 'react';
import { Chart } from "react-google-charts";
import { TimelineDataType } from '../TieredUnitCountTimelineContainer';

interface APTUTimelineProps {
  timelineData: TimelineDataType;
}

const APTUTimeline: React.FC<APTUTimelineProps> = ({ timelineData }) => {
  return (
    <>
      <div style={{
        marginBottom: '10px',
        padding: '8px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
      }}>
        <strong>Note:</strong> Timeline duration is not inclusive of the first day.
        You may need to add a day to the duration for accurate representation.
        <hr style={{ margin: '10px 0' }} />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
          <div>
            <span style={{
              display: 'inline-block',
              width: '15px',
              height: '15px',
              backgroundColor: '#34a853',
              marginRight: '5px',
            }}></span>
            <span>Active APTU (within initial period)</span>
          </div>
          <div>
            <span style={{
              display: 'inline-block',
              width: '15px',
              height: '15px',
              backgroundColor: '#4285f4',
              marginRight: '5px',
            }}></span>
            <span>Inactive APTU (within initial period)</span>
          </div>
          <div>
            <span style={{
              display: 'inline-block',
              width: '15px',
              height: '15px',
              backgroundColor: '#d32f2f',
              opacity: 0.7,
              marginRight: '5px',
            }}></span>
            <span>Extended APTU (outside initial period)</span>
          </div>
          <div>
            <span style={{
              display: 'inline-block',
              width: '15px',
              height: '15px',
              backgroundColor: '#9C27B0',
              opacity: 0.7,
              marginRight: '5px',
            }}></span>
            <span>Initial Period</span>
          </div>
          <div>
            <span style={{
              display: 'inline-block',
              width: '15px',
              height: '15px',
              backgroundColor: '#FFA500',
              opacity: 1,
              marginRight: '5px',
            }}></span>
            <span>Warning (No Initial Period in Range)</span>
          </div>
        </div>
      </div>
      <Chart
        height="400px"
        chartType="Timeline"
        loader={<div>Loading Chart...</div>}
        data={timelineData}
        options={{
          showRowLabels: true,
          avoidOverlappingGridLines: false,
          timeline: {
            groupByRowLabel: true,
            colorByRowLabel: false,
            singleColor: false,
            showBarLabels: true,
            rowLabelStyle: {
              fontName: 'Arial',
              fontSize: 12,
            },
            barLabelStyle: {
              fontName: 'Arial',
              fontSize: 10,
            },
          },
          tooltip: { isHtml: true },
        }}
      />
    </>
  );
};

export default APTUTimeline;
